import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

/**
 * DTO de réponse pour un type de matière (SubjectTypeExternalRef)
 */
export class SubjectTypeDto {
  @ApiProperty({
    description: "ID du type de matière",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: 'Code du type de matière',
    example: 'SCIENCES',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    description: 'Libellé du type de matière',
    example: 'Sciences',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  label!: string

  @ApiPropertyOptional({
    description: 'Couleur associée (hex)',
    example: '#3B82F6',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  color?: string
}
